t = require('app/scripts/views/internal/recup-with-helpers')('manage_members')

Member = require './member'

module.exports = t.statelessRenderable 'MemberList', ({ members, selectedMembers, toggleMember }) ->
  t.div ->
    t.div '.member-list-header', ->
      t.div '.name.quiet', -> t.format 'name'
      t.div '.select.quiet', -> t.format 'select'
    members.forEach (member) ->
      isSelected = selectedMembers.some (id) -> id == member.id

      t.createElement Member, { isSelected, member, toggleMember }
